import React from 'react';
import { useState } from 'react';
import { getUserDetailsCookie } from '../../../Api/Utils/apiUtils';

const AddBudgetItem = ({saveitem, cancleItem, eventID}) => {
    const [itemName, setitemName] = useState('');
    const [amount, setamount] = useState('');

    function saveHandle() {
        const user = getUserDetailsCookie()
        const itemdata ={
            eventId: eventID,
            itemName: itemName,
            price: amount,
            buyerId: user.id
        }
        saveitem(itemdata)
        setitemName('')
        setamount('')
    }

    function cancleHandle() {
        cancleItem(false)
        setitemName('')
        setamount('')
    }

    return (
    <>
        <div className="empty-space-card"></div>
        <div className='add-budget-item-overlay'>
            <div className="add-budget-card">
                <h4>Manage Budget</h4>
                <input type="text" value={itemName} placeholder='Item Name' onChange={(e) => setitemName(e.target.value)} />

                <input type="text" value={amount} placeholder='Amount' onChange={(e) => setamount(e.target.value)} />
                <button className="save" onClick={saveHandle}>Save</button>
                <button onClick={cancleHandle} className="cancle">Cancle</button>
            </div>
        </div>
    </>
    );
};

export default AddBudgetItem;
